__turbopack_context__.v({
  "blue": "Byline-module-scss-module__87xf9G__blue",
  "byline": "Byline-module-scss-module__87xf9G__byline",
  "chip": "Byline-module-scss-module__87xf9G__chip",
  "chipWrapper": "Byline-module-scss-module__87xf9G__chipWrapper",
  "darkBlue": "Byline-module-scss-module__87xf9G__darkBlue",
  "hero": "Byline-module-scss-module__87xf9G__hero",
  "icon": "Byline-module-scss-module__87xf9G__icon",
  "innerChip": "Byline-module-scss-module__87xf9G__innerChip",
  "link": "Byline-module-scss-module__87xf9G__link",
  "mediaLeft": "Byline-module-scss-module__87xf9G__mediaLeft",
  "mediaRight": "Byline-module-scss-module__87xf9G__mediaRight",
});
